import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const bulkUpdate =
  (communityIdentifier: string, contentPayload: Types.PayloadData[]) =>
   Request.requestActionCreator(Constants.UPDATE_OR_CREATE_CONFIG)
     ({
       method: 'PUT',
       payload: contentPayload,
       url: `/communities/${communityIdentifier}/config`,
    })

export const selectPartner = (partnerCode: string) =>
  ({type: Constants.SELECT_PARTNER_CODE, partner: partnerCode})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/actions.ts